/** Powerful Sword Run: the forward source travels 2.38 m over a 0.683 s
 * cycle (~3.49 m/s). A longer reach carries the same travel at a lighter,
 * slower cadence. All eight clips share a phase. */
export const BLADE_MOVE_SPEED = 3.5;
export const BLADE_JOG_SPEED = 4.5;
export function bladeRunCadence(speed:number):number {
  return Math.max(.6,Math.min(1.02,.84+(speed-BLADE_MOVE_SPEED)*.16));
}

/** Match the slower cycle by covering more ground per stride, not sliding a
 * short-stride animation faster. Keep extreme recovery speeds within anatomy. */
export function bladeStrideScale(speed:number):number {
  return Math.max(1,Math.min(1.3,speed/(3.485*bladeRunCadence(speed))));
}
